import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H5 from '@base/H5/H5';
import Image from '@base/Image';
import useCountdown from '@comp/Countdown/useCountdown';
import { pluralize } from '@utils/textHelper';
import { Spacings, Fonts } from '@styles/index';
import { zeroPad } from '../../../utils';

const DefaultBackgroundImage = 'quiz/default-counter-background.svg';
const DefaultEmptyImage = 'quiz/default-empty.svg';

const Wrapper = styled.div`
  position: relative;
`;

const Absolute = styled.div`
  width: 186px;
  position: absolute;
  z-index: 1;
  top: ${Spacings.SPACING_14B};
  text-align: center;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`;

const Label = styled(H5)`
  margin-bottom: ${Spacings.SPACING_3B};
`;

const CounterWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
`;

const CountdownValue = styled.div`
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-i-light-orange);
  font-size: ${Fonts.H2};
  border-radius: ${Spacings.SPACING_1B};
  width: ${Spacings.SPACING_14B};
  height: ${Spacings.SPACING_14B};
  margin-bottom: ${Spacings.SPACING_1B};
`;

const CountdownLabel = styled.div`
  text-align: center;
  color: var(--color-text-secondary);
  font-size: ${Fonts.H7};
`;

const pluralizeWithoutCount = (count, text) =>
  pluralize(count, text, 's', true);

const Timer = ({ label, timestamp, onExpire, isGTP }) => {
  const { hours, minutes, seconds } = useCountdown(timestamp, onExpire);

  return (
    <Wrapper>
      {!isGTP && (
        <Absolute>
          <Label>{label}</Label>
          <CounterWrapper>
            <div>
              <CountdownValue>{zeroPad(hours)}</CountdownValue>
              <CountdownLabel>
                {pluralizeWithoutCount(hours, 'hour')}
              </CountdownLabel>
            </div>
            <div>
              <CountdownValue>{zeroPad(minutes)}</CountdownValue>
              <CountdownLabel>
                {pluralizeWithoutCount(minutes, 'minute')}
              </CountdownLabel>
            </div>
            <div>
              <CountdownValue>{zeroPad(seconds)}</CountdownValue>
              <CountdownLabel>
                {pluralizeWithoutCount(seconds, 'second')}
              </CountdownLabel>
            </div>
          </CounterWrapper>
        </Absolute>
      )}
      <Image
        height={260}
        width={360}
        src={isGTP ? DefaultEmptyImage : DefaultBackgroundImage}
        alt="timer"
      />
    </Wrapper>
  );
};

export default Timer;

Timer.propTypes = {
  timestamp: PropTypes.number.isRequired, // in milliseconds
  onExpire: PropTypes.func.isRequired
};
